import Vue from "vue";
//模块功能：产品详情-船舶动态监控与预警
export default Vue.extend({
    name: "ship-warning",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        contents: function () {
            return this.$t('productsdetail.alert');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/ship-warning.vue
// module id = null
// module chunks = 